import { useCallback, useContext, useMemo } from 'react';
import { useCookies } from 'react-cookie';
import { useSearchParams } from 'react-router-dom';
import { UserContext } from '../../context';
import { StoryCardStatus } from '../../services';
import { getSearchFeed, loadMoreSearchFeed } from '../../slices';
import { SEARCH_ADMIN_COOKIE_KEY } from '../constants';
import { isAdminLayout } from '../utils';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { useLastDate } from './useLastDate';
import { useSearchByTags } from './useSearchByTags';

export const useSearchFeed = () => {
  const dispatch = useAppDispatch();

  const { getDateRange } = useLastDate();

  const [cookies] = useCookies([SEARCH_ADMIN_COOKIE_KEY]);

  const [searchParams] = useSearchParams();

  const { tagIdsToSearchBy } = useSearchByTags();

  const { page } = useAppSelector(({ searchFeed }) => searchFeed);

  const { channelId } = useContext(UserContext).userInfo.userData;

  const { requestFilter = {} } = { ...cookies[SEARCH_ADMIN_COOKIE_KEY] };

  const { dateRange = {}, ...requestFilterRest } = { ...requestFilter };

  const filter = useMemo(() => {
    if (!isAdminLayout()) {
      return { status: [StoryCardStatus.PUBLISHED], ...tagIdsToSearchBy };
    }
    return { ...requestFilterRest, ...getDateRange(dateRange), ...tagIdsToSearchBy };
  }, [dateRange, getDateRange, requestFilterRest, tagIdsToSearchBy]);

  const query = (searchParams.get('qs') ?? '').replace(/\\|"|'/g, '');

  const getSearchFeedItems = useCallback(
    () => dispatch(getSearchFeed({ channelId, filters: { ...filter, query } })),
    [channelId, dispatch, filter, query]
  );

  const loadMoreSearchFeedItems = useCallback(
    () =>
      dispatch(loadMoreSearchFeed({ channelId, page: page + 1, filters: { ...filter, query } })),
    [channelId, dispatch, filter, page, query]
  );

  return { getSearchFeedItems, loadMoreSearchFeedItems };
};
